<template>
  <div>
    <div
      v-if="searchable && searchPlace === 'top'"
      class="search-con search-con-top"
    >
      <Select v-model="searchKey" class="search-col">
        <Option
          v-for="item in arearIndexs"
          :value="item.key"
          :key="`search-col-${item.key}`"
          >{{ item.title }}
        </Option>
      </Select>
      <Input
        @on-change="handleClear"
        clearable
        placeholder="输入关键字搜索"
        class="search-input"
        v-model="searchValue"
      />

      <Button
        @click="handleSearch"
        class="search-btn"
        type="primary"
        icon="ios-search"
      >
        搜索</Button
      >
    </div>
    <Table
      :loading="loading"
      :border="showBorder"
      :stripe="showStripe"
      :show-header="showHeader"
      :height="fixedHeader ? 500 : ''"
      :size="tableSize"
      :data="tableData"
      :columns="tableColumns"
      :highlight-row="highlightRow"
      :editable="editable"
      :searchable="searchable"
      :searchPlace="searchPlace"
      @on-select="selectme"
      @on-select-cancel="selectmeCancel"
      @on-select-all="selectmeBatch"
      @on-select-all-cancel="selectmeBatchCancel"
      tooltip-theme="dark"
      ref="selection"
      :show-footer="showFooter"
    >

    </Table>

    <div style="margin: 10px;overflow: hidden">
      <!-- <div style="float:left">
        <Button @click="handleSelectAll(true)">批量选择</Button>
        <Button @click="handleSelectAll(false)">取消批量选择</Button>
         <Button class="black-button">批量彻底拉黑</Button>
      </div> -->
      <div style="float: right;" v-if="showFooter">
        <Page
          :total="infoTotal"
          :page-size="rowNums"
          :current="curpage"
          show-total
          show-sizer
          show-elevator
          v-if="tableType == 'default'"
          @on-page-size-change="changePageSize"
          @on-change="changePage"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
import '_c/caijisystem/tables/search.less';
import expandRow from '_c/caijisystem/tables/table-expand.vue';
export default {
  name: 'allbalck1',
  components: { expandRow },
  data () {
    return {
      tableData: [],
      sourceFilter: [
        { label: '58同城', value: '1' },
        { label: '赶集网', value: '2' }
      ],
      timeFilter: [],
      Areafilters: [
        {
          label: '黄浦',
          value: '黄浦'
        }
      ],
      showBorder: true, // 显示表格列边框
      showStripe: true, // 显示斑马线样式
      showHeader: true, // 显示表头
      showIndex: true, // 显示索引序号
      showExpand: false, // 显示简要介绍
      showCheckbox: false, // 显示复选框/
      showNoteTime: false, // 显示备注时间
      fixedHeader: false, // 固定表头
      highlightRow: true, // 高亮选择的行
      searchable: true,
      searchPlace: 'top',
      searchKey: '',
      searchValue: '',
      editIndex: -1,
      editNote: '',
      editable: true, // 全局设置是否可编辑

      loading: false,
      // tooltip: true,
      tableSize: 'small',
      showFooter: true,

      fromPage: 1,
      rowNums: 50,
      infoTotal: 0,
      isClicked: true,

      tableType: 'default',
      isAutoRefreshed: false,
      refreshTime: 120000
    };
  },
  computed: {
    arearIndexs () {
      let tables = this.tableColumns;
      let newTableColumns = [];

      for (let i = 0; i < tables.length; i++) {
        let item = tables[i];
        if (
          item.hasOwnProperty('key') &&
          item.key !== 'note' &&
          item.key !== 'noteTime' &&
          item.key !== 'time'
        ) {
          newTableColumns.push(tables[i]);
        }
      }

      return newTableColumns;
    },
    curpage () {
      return this.fromPage;
    },
    tableColumns () {
      let columns = [];
      if (this.showCheckbox) {
        columns.push({
          type: 'selection',
          width: 60,
          align: 'center'
        });
      }
      if (this.showIndex) {
        columns.push({
          type: 'index',
          width: 50,
          align: 'center'
        });
      }
      if (this.showExpand) {
        columns.push({
          type: 'expand',
          width: 60,
          align: 'center',
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row
              }
            });
          }
        });
      }

      columns.push({
        title: '发布时间',
        key: 'time',
        sortable: true,
        width: 150,
        align: 'center'
      });
      columns.push({
        title: '标题',
        key: 'title',
        width: 'auto',
        minWidth: 220
      });

      columns.push({
        title: '区域',
        key: 'area',
        sortable: false,
        width: 'auto',
        minWidth: 180,
        align: 'center'
      });
      columns.push({
        title: '手机号',
        key: 'phone',
        width: 112,
        align: 'center'
      });

      return columns;
    }
  },
  created () {
    this.getInfos(this.fromPage, this.rowNums);
    this.getInfoTotal();
  },
  mounted () {},
  methods: {
    getListBynote () {
      this.loading = true;
      let userId = this.$store.state.user.userId;
      this.$axios
        .request({
          url: 'caiji/?s=info.getlistwithnote&userId=' + userId,
          method: 'GET'
        })
        .then(json => {
          console.log(json);

          this.tableData = json.data.data;
          this.tableType = 'note';
          this.loading = false;
        });
    },

    getBlackList () {
      this.loading = true;
      let userId = this.$store.state.user.userId;
      this.$axios
        .request({
          url: 'caiji/?s=info.getlistwithblack&userId=' + userId,
          method: 'GET'
        })
        .then(json => {
          console.log(json);
          this.tableData = json.data.data;
          this.tableType = 'black';
          this.loading = false;
        });
    },

    note () {
      this.showExpand = true;
    },

    reload () {
      this.getInfos(this.fromPage, this.rowNums);
      this.getInfoTotal();
      this.showFooter = true;
      this.tableType = 'default';
    },

    gettime (value, row) {
      return row.time.indexOf(value) > -1;
    },

    getInfoTotal () {
      this.$axios
        .request({
          url: 'caiji/?s=info2.isBlackCount',
          method: 'GET'
        })
        .then(json => {
          console.log(json);
          this.infoTotal = Number(json.data.data);
        });
    },

    // 获取列表信息
    getInfos (fromPage, rowNums) {
      this.loading = true;
      let userId = this.$store.state.user.userId;
      this.$axios
        .request({
          url:
            'caiji/?s=info2.isblack&isBlack=1&userId=' +
            userId +
            '&from=' +
            fromPage +
            '&nums=' +
            rowNums,
          method: 'GET'
        })
        .then(json => {
          console.log(json);

          let datalist = json.data.data;
          // let tempList = [];
          // for (let i = 0; i < datalist.length; i++) {
          //   datalist[i].isClick = false;
          //   if (datalist[i].isBlack) {
          //     tempList.push(datalist[i]);
          //   }
          // }

          this.tableType = 'default';
          this.tableData = datalist;

          this.loading = false;
        });
    },

    handleSelectAll (status) {
      this.$refs.selection.selectAll(status);
    },

    selectme (data) {
      console.log('select_this_data', data);
      const token = this.$store.state.user.token;
      console.log('token', token);
    },
    selectmeCancel (data) {
      console.log('select_this_data', data);
      const token = this.$store.state.user.token;
      console.log('token', token);
    },
    goto (data) {
      console.log('gotOdata', data);
      window.open(data.link);
      data.isClick = true;
    },
    selectmeBatch (data) {
      let _arr = [];
      data.map(s => {
        _arr.push(s.id);
      });

      let datas = Array.from(new Set(_arr));
      console.log('datas', datas);
    },
    selectmeBatchCancel (data) {
      data.map(s => {
        console.log(s);
      });
    },
    changePage (pageNumber) {
      // this.fromPage = pageNumber;
      // TODO:根据tableType来调用不同的方法带分页功能
      this.fromPage = pageNumber;
      this.getInfos(pageNumber, this.rowNums);
      // console.log('下页数据', pageNumber);
    },
    changePageSize (pageSize) {
      // console.log('pageSize', pageSize)
      this.rowNums = pageSize;
      // console.log('frompage', this.fromPage)
      this.getInfos(this.fromPage, this.rowNums);
    },
    handleClear (e) {
      console.log('cleardata', e);
      // if (e.target.value === '') this.insideTableData = this.value;
    },
    handleSearch () {
      let skey = this.searchKey;
      let svalue = this.searchValue;
      let data = {};
      let tt = null;
      this.tableType = 'search';
      if (skey === 'area') {
        if (!this.isAutoRefreshed) {
          if (tt) {
            clearTimeout(tt);
          }
        } else {
          let _this = this;
          tt = setTimeout(() => {
            _this.handleSearch();
          }, this.refreshTime);
        }
      } else {
        this.isAutoRefreshed = false;
        if (tt) {
          clearTimeout(tt);
        }
      }
      data[skey] = svalue;
      data['userId'] = this.$store.state.user.userId;
      console.log('searchkey', data);
      this.loading = true;

      this.$axios
        .request({
          url: 'caiji/?s=info.search',
          data: data,
          method: 'POST'
        })
        .then(json => {
          console.log('search结果：', json);
          this.loading = false;
          this.tableData = json.data.data;
          this.showFooter = false;
        });
    },
    noteedit (row, index) {
      this.editNote = row.note;
      this.editIndex = index;
    },
    notesave (row) {
      if (!this.editNote) {
        this.editIndex = -1;
      } else {
        row.note = this.editNote;

        this.editIndex = -1;

        console.log(row);
        let userId = this.$store.state.user.userId;
        let postData = {
          phone: row.phone,
          note: row.note,
          userId: userId
        };
        this.$axios
          .request({
            url: 'caiji/?s=note.save',
            data: postData,
            method: 'POST'
          })
          .then(json => {
            console.log('noteSave', json);
            let jsonData = json.data;
            if (jsonData.ret === 200) {
              this.$Message.success('备注保存成功,请进入已备注的信息中查看');
              // if (this.tableType === 'default') {
              //   this.reload();
              // } else if (this.tableType === 'note') {
              //   this.getListBynote();
              // } else if (this.tableType === 'search') {
              //   this.handleSearch();
              // } else if (this.tableType === 'black') {
              //   this.getBlackList();
              // }
            } else {
              this.$Message.error(jsonData.msg);
            }
          });
      }
    },
    blacksave (row) {
      console.log(row);
      let userId = this.$store.state.user.userId;
      let postData = {
        phone: row.phone,
        id: row.id,
        userId: userId,
        isBlack: 1
      };
      this.$axios
        .request({
          url: 'caiji/?s=info.edit&__debug__=1',
          data: postData,
          method: 'POST'
        })
        .then(json => {
          console.log('blacklist', json);
          let jsonData = json.data;
          if (jsonData.ret === 200) {
            this.$Message.success('信息已经列入黑名单!');
            // if (this.tableType === 'default') {
            //   this.reload();
            // } else if (this.tableType === 'note') {
            //   this.getListBynote();
            // } else if (this.tableType === 'search') {
            //   this.handleSearch();
            // } else if (this.tableType === 'black') {
            //   this.getBlackList();
            // }
          } else {
            this.$Message.error(jsonData.msg);
          }
        })
        .catch(err => {
          this.$Message.success('发生异常!' + err.response.data.msg);
        });
    },
    unblacksave (row) {
      console.log(row);
      let userId = this.$store.state.user.userId;
      let postData = {
        phone: row.phone,
        userId: userId,
        note: 'null'
      };
      this.$axios
        .request({
          url: 'caiji/?s=note.save',
          data: postData,
          method: 'POST'
        })
        .then(json => {
          console.log('blacklist', json);
          let jsonData = json.data;
          if (jsonData.ret === 200) {
            this.$Message.success('信息已经恢复到正常列表中!');
            // if (this.tableType === 'default') {
            //   this.reload();
            // } else if (this.tableType === 'note') {
            //   this.getListBynote();
            // } else if (this.tableType === 'search') {
            //   this.handleSearch();
            // } else if (this.tableType === 'black') {
            //   this.getBlackList();
            // }
          } else {
            this.$Message.error(jsonData.msg);
          }
        });
    }
  }
};
</script>
<style scoped>
.notewithother {
  border: 1px solid red;
}
.note-input {
  width: 100%;
}
.black-button {
  background: #141414;
}
.ivu-btn-primary {
  background: #eeeeee;
}

a {
  width: 100%;
  height: 100%;
}
a:link {
  color: white;
}
a:visited {
  color: #ff9900;
  background: #141414;
  /* color: white; */
  background: grey;
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
}
a:hover {
  display: block;
  color: white;
  background: grey;
  width: 100%;
  height: 100%;
  z-index: 10;
}
.refresh {
  width: auto;
  height: 24px;
  line-height: 24px;
  margin-left: 20px;
}
</style>
